// Shared SelectWithCreate Component
// A select dropdown with an inline "create new" button
// Design: Black (#000), Bone (#fffbf7), Sage (#a1c6a2)
import React from 'react';

const SelectWithCreate = ({
  label,
  name,
  value,
  options = [],
  onChange,
  onCreateNew,
  placeholder = '-- Select --',
  required = false,
  disabled = false,
  loading = false,
  createLabel = 'Create New',
}) => {
  const handleChange = (e) => {
    onChange(e.target.value);
  };

  return (
    <div>
      <label
        htmlFor={name}
        className="text-[10px] text-[rgba(255,251,247,0.4)] tracking-[0.2em] uppercase block mb-2"
        style={{ fontFamily: "'GT Pressura Mono', monospace" }}
      >
        {label} {required && <span className="text-[#c47474]">*</span>}
      </label>
      <div className="flex gap-2">
        <select
          name={name}
          id={name}
          value={value}
          onChange={handleChange}
          disabled={disabled || loading}
          required={required}
          className="flex-1 px-4 py-3 border border-[rgba(255,251,247,0.2)] bg-black text-[#fffbf7] text-sm focus:outline-none focus:border-[#a1c6a2] transition-colors disabled:opacity-50"
        >
          <option value="">{loading ? 'Loading...' : placeholder}</option>
          {options.map(opt => (
            <option key={opt.id} value={opt.id}>{opt.name}</option>
          ))}
        </select>
        <button
          type="button"
          onClick={onCreateNew}
          disabled={disabled || loading}
          className="px-3 py-3 border border-[#a1c6a2] text-[#a1c6a2] hover:bg-[#a1c6a2] hover:text-black transition-colors disabled:opacity-50 disabled:cursor-not-allowed flex items-center gap-1"
          title={createLabel}
        >
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
          </svg>
          <span
            className="text-[10px] tracking-[0.1em] uppercase hidden sm:inline"
            style={{ fontFamily: "'GT Pressura Mono', monospace" }}
          >
            New
          </span>
        </button>
      </div>
    </div>
  );
};

export default SelectWithCreate;
